export const ROLES = {
    User: 'USER',
    Manager: 'MANAGER',
    Admin: 'ADMIN'
}